import MyItems from './TopItems';
import TopPart from './TopPart';


export default {
  name: 'dn-top-parts',

  components: {
    MyItems,
  },

  data() {
    const categories = this.getCategories();
    return {
      categories,
      defaultOrders: categories.map(c => c.id),
    }
  },

  computed: {
    orders() {
      return this.$store.getters['top/parts/orders'] || this.defaultOrders;
    },
    spreadThreshold() {
      return  Math.floor(this.categories.length / 2);
    },
  },

  methods: {
    getCategories() {
      const categories = [];
      const $data = $('#data-pg-parts');
      const $categories = $data.children('.category');
      $categories.each(function() {
        const $category = $(this);
        const $label = $category.children('.label');
        const $description = $category.children('.description');
        const $groups = $category.children('.group');
        const $notes = $category.children('.notes');

        const categoryData = $category.data();
        const category = {
          id: categoryData.id,
          status: categoryData.status !== undefined ? String(categoryData.status) : null,
          label: $label.html() || null,
          description: $description.html() || null,
          groups: [],
          notes: $notes.html() || null,
          plainLink: categoryData.plainLink,
        };

        $groups.each(function() {
          const $group = $(this);
          const groupData = $group.data();
          const $label = $group.children('.label');
          const $links = $group.children('a');
          const group = {
            id: groupData.id,
            label: $label.html() || null,
            links: [],
          };
          category.groups.push(group);

          $links.each(function() {
            const $link = $(this);
            const linkData = $link.data();
            const link = {
              href: $link.prop('href'),
              label: $link.html(),
              auth: !!linkData.auth || linkData.auth === '',
              target: $link.prop('target') || null,
              url_id: linkData.url_id || null,
            };
            group.links.push(link);
          });
        });
        categories.push(category);
      });
      return categories;
    },
  },

  created() {
    this.getCategories();
  },

  render(h) {
    const itemsBand = {
      first : [],
      banner: [h('dn-bc-banner', {
        staticClass: 'pg-items__banner',
        props: {
          screen: '102',
          type: '04,05',
        },
      })],
      spBanner: [h('dn-bc-banner', {
        staticClass: 'pg-items__banner',
        props: {
          screen: '102',
          type: '04,05',
        },
      })],
      second: [],
    };

    const { categories, orders, spreadThreshold } = this;
    orders.forEach((id, index) => {
      const category = categories.find(c => c.id === id);
      const myTarget = index < spreadThreshold ? 'first' : 'second';
      const part = h(TopPart, {
        props: {
          index,
          id,
          label: category.label,
          description: category.description,
          groups: category.groups,
          notes: category.notes,
          status: category.status,
          plain: category.plainLink,
        },
        key: id,
      });
      itemsBand[myTarget].push(part);
    });

    // const $twitterTimeline = h('div', {
    //   staticClass: 'pg-item-frame pg-item-frame--tw-timeline',
    //   props: {id: 'tw-timeline'},
    //   key: 'tw-timeline',
    // }, [
    //   h('h2', {
    //     staticClass: 'dn-heading-2',
    //   }, 'データネット公式Twitter'),
    //   h('dn-twitter-timeline', {
    //     props: {
    //       href: 'https://twitter.com/kyotsu_DN?ref_src=twsrc%5Etfw',
    //     },
    //   }, 'Tweets by center_DN')
    // ]);

    // itemsBand.second.push($twitterTimeline);

    return h('div', {
      staticClass: 'pg-container',
    }, [
      h('my-items', {props: {id: 'first' }}, itemsBand.first),
      h('my-items', {props: {id: 'banner'}}, itemsBand.banner),
      h('my-items', {props: {id: 'sp-banner'}}, itemsBand.spBanner),
      h('my-items', {props: {id: 'second'}}, itemsBand.second),
    ]);
  },
}



// WEBPACK FOOTER //
// ./src/js/top/components/TopParts.js